import { Dispatch, SetStateAction, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { resendSubmissionEmail as resendSubmissionEmailService } from '../../../services/form/FormService';

interface Values {
  isLoading: boolean;
  resendSubmissionEmail: (formId: string, submissionId: string, email: string) => Promise<number>;
  setOrganizationId: Dispatch<SetStateAction<string>>;
}

const useResendSubmissionEmail = (organizationId: string): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [id, setOrganizationId] = useState<string>(organizationId);

  const resendSubmissionEmail = async (formId: string, submissionId: string, email: string): Promise<number> => {
    try {
      setIsLoading(true);

      const result = await resendSubmissionEmailService(id, formId, submissionId, email);
      setIsLoading(false);
      return result.data;
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      return 0;
    }
  };

  return { resendSubmissionEmail, isLoading, setOrganizationId };
};

export default useResendSubmissionEmail;
